import $ from "jquery";
import lightbox2 from "lightbox2";



export function lightbox() {
	lightbox.option({
		'resizeDuration': 200,
		'wrapAround': true,
		'imageFadeDuration': 300,
		'fitImagesInViewport': true,

	});

}



// WEBPACK FOOTER //
// ./src/js/components/lightbox.js